export const API_URL = 'https://apihml.cadedireito.com.br/v1';

export const INSTAGRAM_URL = 'https://www.instagram.com/cade.direito'

var __RECAPTCHA_ID
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
  __RECAPTCHA_ID = '6LcPDewUAAAAADRrThmIgg04qkKgTtqyz5ye4hCs'
} else { 
  __RECAPTCHA_ID = '6LceDOwUAAAAAERRgivv0neACn7aweXhd_loca3l'
}

export const RECAPTCHA_ID = __RECAPTCHA_ID;
export const GA_TRACKING_ID = 'G-WYGX0RDBWD';
